<script setup>
import axios from "axios";
import {ref} from 'vue';

const pis = ref([]);
const isLoading = ref(false);

async function getPis() {
  try {
    const response = await axios.get('/competition/report_128_pis');
		pis.value = response.data;
  } catch (error) {
    console.log(error);
  }
}
getPis();

const columns = ref([
  {
    title: 'Проект',
    dataIndex: 'project_name',
    key: 'project_name',
  }
]);

</script>

<template>
  <div>
	  <a-table
		  :columns="columns"
		  :data-source="pis"
	  ></a-table>


  </div>
</template>

<style scoped>

</style>